import microuniversoApi from "app/api/microuniversoApi"
import { atualizarItemAction, sobrescreverInformacoesAction } from "app/redux/orcamentoSlice"
import store from "app/redux/store/store"
import { IOrcamento } from "app/types/IOrcamento"
import {CriaOrcamentoAposTotalizador} from "../../utils/CriaOrcamentoAposTotalizador";
import * as atualizacaoItensOrcamentoLegadoActions from 'app/redux/atualizacaoItensOrcamentoLegadoSlice'



declare var window:any

export type DefinirValorDescontoAcumuladoInput = {
    valorDescontoAcumulado: number
}

export async function definirValorDescontoAcumulado(input: DefinirValorDescontoAcumuladoInput) {

    const orcamentoAtualizado = await microuniversoApi.Orcamento.definirValorDescontoAcumulado(
        store.getState().orcamento.IdentificadorOrcamento,
        input.valorDescontoAcumulado
    )

    const atualizarOrcamentoLegadoERedux = () => {
        const orcamentoLegado = window.orcamentoController.model
        const orcamentoReact = store.getState().orcamento
        const novosOrcamentos = CriaOrcamentoAposTotalizador(orcamentoReact, orcamentoLegado, orcamentoAtualizado)

        orcamentoLegado.atualizar(novosOrcamentos.orcamentoLegado)

        store.dispatch(sobrescreverInformacoesAction(novosOrcamentos.orcamentoReact))

        const atualizarEstadoItensLegado = () => {
            //const itensLegado = orcamentoLegado.get('ItensOrcamento')

            for(let itemAtualizado of (orcamentoAtualizado.ItensOrcamento ?? [])) {
                //const itemLegado = itensLegado.models.find(i => i.get('Identificador') == itemAtualizado.Identificador)
                //itemLegado.atualizar(itemAtualizado,true,true,true)

                store.dispatch(atualizacaoItensOrcamentoLegadoActions.atualizarItem({
                    identificador: itemAtualizado.Identificador,
                    dadosItem: itemAtualizado
                }))
            }
        }

        atualizarEstadoItensLegado()

    }


    atualizarOrcamentoLegadoERedux()
}
